import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {RestoreUtils} from "../misc/RestoreUtils";

export class DoZeroBet implements SimplePresentation {

    shouldRun(): boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        const isFastDrops = FlightMode.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const usedAFreespin = FlightMode.model.usedAFreespin();
        const targetFreespins = FlightMode.model.freespinsLeft - 1;

        tl.add(() => {
            FlightMode.apiPlugin.betHandler.zeroBet();
        });

        if (FlightMode.model.usedAFreespin()) {
            if (FlightMode.model.isRestore || FlightMode.model.avalancheWin == 0)
                tl.add(() => {}, 0.25);
            tl.add(FlightMode.reelView.dropOutSymbols(isFastDrops));
        }

        if (FlightMode.model.playedExtraSpin())
            tl.add(FlightMode.reelView.dropOutSymbols(isFastDrops));

        tl.add(() => {
            if (usedAFreespin)
                FlightMode.keypadPlugin.setZeroBetSpinCounter(targetFreespins);
            controller.finish();
        }, '>');
    }
}
